import { render, staticRenderFns } from "./InstitutionEditor.vue?vue&type=template&id=005bff84&scoped=true&"
import script from "./InstitutionEditor.vue?vue&type=script&lang=ts&"
export * from "./InstitutionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionEditor.vue?vue&type=style&index=0&id=005bff84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005bff84",
  null
  
)

export default component.exports